import { Routes, Route } from 'react-router-dom';
import CarrierLookupList from './widgets/CarrierLookupList';

interface CarrierLookupProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
}

function CarrierLookup({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
}: CarrierLookupProps) {
  const props = {
    userType,
    currentPage,
    currentTab,
    setCurrentTab,
    subTab,
    setSubTab,
  };
  return (
    <Routes>
      <Route path="/" element={<CarrierLookupList {...props} />} />
    </Routes>
  );
}

export default CarrierLookup;
